import { Funnel } from "@phosphor-icons/react"
import {
  Button,
  FilterDrawer,
  FormQuerySelector,
  FormSelector,
} from "@vesatogo/grass-core"
import { FormDateInput } from "@vesatogo/grass-dates"
import { Dispatch, SetStateAction, useState } from "react"
import { useAllStorageKindsQuery } from "~/generated/graphql"

export type StorageFilter = {
  agreement_end_date_from?: any
  agreement_end_date_to?: any
  is_active?: any
  is_verified?: any
  tenure_kind?: any
  ownership_kind?: any
  agreement_start_date_from?: any
  agreement_start_date_to?: any
  created_at_from?: any
  created_at_to?: any
  sub_location_kind?: any
}

type Props = {
  filter: StorageFilter
  setFilter: Dispatch<SetStateAction<StorageFilter>>
  // getInputProps: GetInputProps<StorageFilter>
}

export const StorageLocationFilters = ({
  filter,
  setFilter,
}: // getInputProps,
Props) => {
  const [isOpen, setOpen] = useState(false)
  return (
    <>
      <Button
        variant={Object.values(filter)?.length > 0 ? "solid" : "outline"}
        className="whitespace-nowrap"
        onClick={() => setOpen(true)}
      >
        <Funnel />
      </Button>
      <FilterDrawer
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        onApply={() => setOpen(false)}
        onClearAll={() => {
          setFilter({})
          setOpen(false)
        }}
        tabs={[
          {
            id: 1,
            title: "Date",
            content: (
              <div className="flex flex-col gap-3">
                <FormDateInput
                  label="Agreement Start Date From"
                  className="w-full"
                  value={filter.agreement_start_date_from}
                  onChange={value =>
                    setFilter(prev => ({
                      ...prev,
                      agreement_start_date_from: value,
                    }))
                  }
                  // {...getInputProps("agreement_start_date_from")}
                ></FormDateInput>
                <FormDateInput
                  label="Agreement Start Date To"
                  className="w-full"
                  value={filter.agreement_start_date_to}
                  onChange={value =>
                    setFilter(prev => ({
                      ...prev,
                      agreement_start_date_to: value,
                    }))
                  }
                  // {...getInputProps("agreement_start_date_to")}
                ></FormDateInput>
                <FormDateInput
                  label="Agreement End Date From"
                  className="w-full"
                  value={filter.agreement_end_date_from}
                  onChange={value =>
                    setFilter(prev => ({
                      ...prev,
                      agreement_end_date_from: value,
                    }))
                  }
                  // {...getInputProps("agreement_end_date_from")}
                ></FormDateInput>
                <FormDateInput
                  label="Agreement End Date To"
                  className="w-full"
                  value={filter.agreement_end_date_to}
                  onChange={value =>
                    setFilter(prev => ({
                      ...prev,
                      agreement_end_date_to: value,
                    }))
                  }
                  // {...getInputProps("agreement_end_date_to")}
                ></FormDateInput>

                <FormDateInput
                  label="Created Date From"
                  className="w-full"
                  value={filter.created_at_from}
                  onChange={value =>
                    setFilter(prev => ({
                      ...prev,
                      created_at_from: value,
                    }))
                  }
                  // {...getInputProps("created_at_from")}
                ></FormDateInput>
                <FormDateInput
                  label="Created Date To"
                  className="w-full"
                  value={filter.created_at_to}
                  onChange={value =>
                    setFilter(prev => ({
                      ...prev,
                      created_at_to: value,
                    }))
                  }
                  // {...getInputProps("created_at_to")}
                ></FormDateInput>
              </div>
            ),
          },
          {
            id: 2,
            title: "Status",
            content: (
              <div className="flex flex-col gap-3">
                <FormSelector
                  label={"Is Active"}
                  options={[
                    { id: true, name: "Active" },
                    { id: false, name: "Inactive" },
                  ]}
                  value={filter.is_active}
                  onChange={value =>
                    setFilter(prev => ({
                      ...prev,
                      is_active: value,
                    }))
                  }
                  // {...getInputProps("is_active")}
                />
                <FormSelector
                  label={"Is Verified"}
                  options={[
                    { id: null, name: "Not Verified" },
                    { id: true, name: "Verified" },
                    { id: false, name: "Rejected" },
                  ]}
                  value={filter.is_verified}
                  onChange={value =>
                    setFilter(prev => ({
                      ...prev,
                      is_verified: value,
                    }))
                  }
                  // {...getInputProps("is_verified")}
                />
              </div>
            ),
          },
          {
            id: 3,
            title: "Other",
            content: (
              <div className="flex flex-col gap-3">
                <FormSelector
                  label={"Tenure Kind"}
                  options={[
                    { id: "Monthly", name: "Monthly" },
                    { id: "Yearly", name: "Yearly" },
                  ]}
                  value={filter.tenure_kind}
                  onChange={value =>
                    setFilter(prev => ({
                      ...prev,
                      tenure_kind: value,
                    }))
                  }
                  // {...getInputProps("tenure_kind")}
                />
                <FormSelector
                  label={"Ownership Kind"}
                  options={[
                    { id: "Own", name: "Own" },
                    { id: "Lease", name: "Rent" },
                  ]}
                  value={filter.ownership_kind}
                  onChange={value =>
                    setFilter(prev => ({
                      ...prev,
                      ownership_kind: value,
                    }))
                  }
                  // {...getInputProps("ownership_kind")}
                />
                <FormQuerySelector
                  label={"Sub Location Kind"}
                  dataHook={useAllStorageKindsQuery}
                  value={filter.sub_location_kind}
                  onChange={value =>
                    setFilter(prev => ({
                      ...prev,
                      sub_location_kind: value,
                    }))
                  }
                  // {...getInputProps("sub_location_kind")}
                />
              </div>
            ),
          },
        ]}
      />
    </>
  )
}
